module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAAAXNSR0IArs4c6QAAATNJREFUSEvtlkFOwzAQRb8jwYH8veYCnAdK0wICWkDlOtyArccHAqRBloqUpElsp6hs4u38+W9sj60xOPEyJ+ahGEjyE8DZvtAvETkvKXoKUJsAESnyKBJHEMkZOHql85EeHM/cNKlP4KBpSF4CeE8l5sRV9SKE8NHU9napc26nqlc5pkMaVb0OIbx144PPguQrgMUUqDFm4b3f9eWOvkOSLwBuCqFLEYnF9q7kwyf5DGCZCa1FJBY5uJLAmOmc26pqPWakqqsQQizub742a+3GGLPqvRdj1t77bQoW41k7/DUi+QRg3TG+FZFNDqwYGBNIPgC42wPuReQxFzYJGJOstXVVVd9DrX9005TsIKUtusOUWU68BexMZDn5OZrWZNcFtgakHLccTXOy+98d5lR7rOYH74N4HSRcybkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/resume/download_icon.png
// module id = 759
// module chunks = 1